import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

export interface Suggestion {
  osmId: number;
  label: string;       // “Pamplona, Navarra, España, Europa” ó “España, Europa”
  city?: string;
  region?: string;
  country?: string;
  continent?: string;
  lat: string;
  lon: string;
}

interface NominatimResult {
  osm_id: number;
  display_name: string;
  lat: string;
  lon: string;
  address: {
    city?: string;
    town?: string;
    village?: string;
    county?: string;
    state?: string;
    country?: string;
    continent?: string;
  };
}

@Injectable({ providedIn: 'root' })
export class GeoService {
  private nominatimUrl = 'https://nominatim.openstreetmap.org/search';

  constructor(private http: HttpClient) {}

  /** Busca hasta 10 resultados (país, región o ciudad) según el texto. */
  searchLocations(prefix: string): Observable<Suggestion[]> {
    if (!prefix) return of([]);
    const params = [
      `q=${encodeURIComponent(prefix)}`,
      'format=json',
      'addressdetails=1',
      'limit=10',
      'accept-language=es'
    ].join('&');
    return this.http
      .get<NominatimResult[]>(`${this.nominatimUrl}?${params}`)
      .pipe(
        map(results =>
          results.map(r => {
            const a = r.address;
            // priorizamos city→town→village→county
            const city = a.city || a.town || a.village || a.county;
            const region = a.state;
            const country = a.country;
            const continent = a.continent;
            // construimos etiqueta limpia, saltando undefined
            const parts = [
              city,
              region,
              country,
              continent
            ].filter(Boolean);
            return {
              osmId: r.osm_id,
              label: parts.join(', '),
              city,
              region,
              country,
              continent,
              lat: r.lat,
              lon: r.lon
            };
          })
        )
      );
  }
}
